import { currency, formatDate, formatTime } from '@/shared/lib/format';
import { passbookCurrency } from '@/shared/lib/passbook-utils';
import { formatMovementDelta, movementActionLabel, resolveLogValidUntil, formatMovementValidUntilShort } from '@/features/leads/model/lead-logs';
import type { Passbook, PointLog, PointLogProduct } from '@/shared/types';

function csvEscape(value: string | number): string {
  const s = String(value ?? '');
  if (s.includes('"') || s.includes(',') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

function productLine(p: PointLogProduct): string {
  const name = p.nome ?? p.name ?? '';
  const sku = p.sku ?? '';
  const qty = p.qtde ?? p.qty ?? p.count ?? 1;
  return `${sku} | ${name} (${qty}x)`;
}

export function exportMovementCsv(log: PointLog, labelQtde: string, passbook: Passbook): void {
  const validUntil = resolveLogValidUntil(log, passbook);
  const rows: string[][] = [
    ['Campo', 'Valor'],
    ['Data', `${formatDate(log.date)} ${formatTime(log.date)}`],
    ['Ação', movementActionLabel(log, passbook)],
    [labelQtde, formatMovementDelta(log, passbook)],
    ['Valor da compra', log.price != null ? currency(log.price, passbookCurrency(passbook)) : ''],
    ['Loja', log.loja ?? ''],
    ['Código', log.externalId ?? log._id ?? ''],
    ['Histórico', log.transactionHistory ?? ''],
    ['Produto resgate', log.produtoResgate ?? ''],
    ['Válido até', validUntil ? formatMovementValidUntilShort(new Date(validUntil)) : ''],
  ];

  if (log.products?.length) {
    rows.push(['', '']);
    rows.push(['Itens', '']);
    for (const p of log.products) {
      rows.push(['', productLine(p)]);
    }
  }

  const csv = rows.map((row) => row.map(csvEscape).join(',')).join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const id = log.externalId ?? log._id ?? formatDate(log.date).replace(/\//g, '-');
  a.href = url;
  a.download = `movimentacao-${id}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
